/**
 * SOUL RUGS — Custom 3-Step Variant Selector
 * Width → Length → Tassels
 */
(function(){
'use strict';
const PRODUCT_DATA=window.__SoulRugsProduct;
if(!PRODUCT_DATA)return;
const{variants,productId,currency}=PRODUCT_DATA;
const sizeMatrix={};
variants.forEach(v=>{
  const[width,length,tassels]=v.options;
  const key=`${width}|${length}`;
  if(!sizeMatrix[key])sizeMatrix[key]={width,length,widthFt:parseInt(width),lengthFt:parseInt(length),price:v.price,sizeCm:v.metafields&&v.metafields.size_cm||'',variants:{}};
  sizeMatrix[key].variants[tassels==='With Tassels'?'WT':'NT']=v.id;
});
const allWidths=[...new Set(variants.map(v=>v.options[0]))];
const allLengths=[...new Set(variants.map(v=>v.options[1]))];
const sortFt=arr=>arr.slice().sort((a,b)=>parseInt(a)-parseInt(b));
const widths=sortFt(allWidths);
const lengths=sortFt(allLengths);
function lengthsForWidth(w){return lengths.filter(l=>sizeMatrix[`${w}|${l}`]);}
const container=document.getElementById('pvs-container');
if(!container)return;
let state={width:null,length:null,tassels:null};
let selectedVariantId=null;
function ftToCm(ft){return Math.round(parseInt(ft)*30.48);}
function getSizeCm(w,l){
  const entry=sizeMatrix[`${w}|${l}`];
  if(entry&&entry.sizeCm)return entry.sizeCm;
  return `${ftToCm(w)} × ${ftToCm(l)} cm`;
}
function formatMoney(cents){
  return(cents/100).toLocaleString('en-US',{style:'currency',currency:currency||'USD'});
}
function getPrice(w,l){const entry=sizeMatrix[`${w}|${l}`];return entry?entry.price:null;}
function getVariantId(w,l,t){
  const entry=sizeMatrix[`${w}|${l}`];
  if(!entry)return null;
  return entry.variants[t==='With Tassels'?'WT':'NT']||null;
}
container.innerHTML=`
  <div class="pvs-steps">
    <div class="pvs-step-indicator is-active" data-step="1"><div class="pvs-step-num">1</div><span class="pvs-step-label">Width</span></div>
    <div class="pvs-step-indicator is-locked" data-step="2"><div class="pvs-step-num">2</div><span class="pvs-step-label">Length</span></div>
    <div class="pvs-step-indicator is-locked" data-step="3"><div class="pvs-step-num">3</div><span class="pvs-step-label">Tassels</span></div>
  </div>
  <div class="pvs-step-panel" id="pvs-step-1">
    <div class="pvs-step-header"><span class="pvs-step-title">Width</span><span class="pvs-step-selected" id="pvs-width-selected"></span></div>
    <div class="pvs-options" id="pvs-width-options">${widths.map(w=>`<button class="pvs-btn" data-step="1" data-value="${w}">${w}</button>`).join('')}</div>
  </div>
  <div class="pvs-step-panel is-locked" id="pvs-step-2">
    <div class="pvs-step-header"><span class="pvs-step-title">Length</span><span class="pvs-step-selected" id="pvs-length-selected"></span></div>
    <div class="pvs-options" id="pvs-length-options">${lengths.map(l=>`<button class="pvs-btn" data-step="2" data-value="${l}">${l}</button>`).join('')}</div>
    <div class="pvs-dimensions" id="pvs-dimensions"></div>
  </div>
  <div class="pvs-step-panel is-locked" id="pvs-step-3">
    <div class="pvs-step-header"><span class="pvs-step-title">Tassels</span><span class="pvs-step-selected" id="pvs-tassels-selected"></span></div>
    <div class="pvs-options pvs-options--tassels" id="pvs-tassels-options">
      <button class="pvs-btn pvs-btn--tassel" data-step="3" data-value="No Tassels"><span class="pvs-btn-title">No Tassels</span><span class="pvs-btn-sub">Classic clean edge</span></button>
      <button class="pvs-btn pvs-btn--tassel" data-step="3" data-value="With Tassels"><span class="pvs-btn-title">With Tassels</span><span class="pvs-btn-sub">Traditional fringe finish</span></button>
    </div>
  </div>
  <div class="pvs-price-display" id="pvs-price-display" style="display:none">
    <div class="pvs-price-label">Price</div>
    <div class="pvs-price-value" id="pvs-price-value"></div>
  </div>`;
const stickyEl=document.getElementById('pvs-sticky');
function updateStepIndicators(){
  container.querySelectorAll('.pvs-step-indicator').forEach(el=>{
    const s=parseInt(el.dataset.step);
    el.classList.remove('is-active','is-done','is-locked');
    if(s===1&&state.width)el.classList.add('is-done');
    else if(s===2&&state.length)el.classList.add('is-done');
    else if(s===3&&state.tassels)el.classList.add('is-done');
    else if(s===1)el.classList.add('is-active');
    else if(s===2&&state.width)el.classList.add('is-active');
    else if(s===3&&state.length)el.classList.add('is-active');
    else el.classList.add('is-locked');
  });
}
function updatePanels(){
  const p2=document.getElementById('pvs-step-2');
  const p3=document.getElementById('pvs-step-3');
  if(state.width)p2.classList.remove('is-locked');else p2.classList.add('is-locked');
  if(state.length)p3.classList.remove('is-locked');else p3.classList.add('is-locked');
}
function updateLengthOptions(){
  const opts=document.querySelectorAll('#pvs-length-options .pvs-btn');
  const valid=state.width?new Set(lengthsForWidth(state.width)):new Set();
  opts.forEach(btn=>{
    const v=btn.dataset.value;
    if(valid.has(v)){btn.classList.remove('is-disabled');btn.removeAttribute('disabled');}
    else{btn.classList.add('is-disabled');btn.setAttribute('disabled','');if(state.length===v){state.length=null;document.getElementById('pvs-length-selected').textContent='';} }
    btn.classList.remove('is-selected');
  });
  if(state.length){
    const sel=document.querySelector(`#pvs-length-options .pvs-btn[data-value="${state.length}"]`);
    if(sel&&!sel.classList.contains('is-disabled'))sel.classList.add('is-selected');
    else state.length=null;
  }
}
function updateDimensions(){
  const el=document.getElementById('pvs-dimensions');
  if(state.width&&state.length){el.textContent=`Dimensions: ${getSizeCm(state.width,state.length)}`;el.classList.add('is-visible');}
  else el.classList.remove('is-visible');
}
function updatePrice(){
  const pd=document.getElementById('pvs-price-display');
  const pv=document.getElementById('pvs-price-value');
  if(state.width&&state.length){
    const cents=getPrice(state.width,state.length);
    if(cents!==null){pv.textContent=formatMoney(cents);pd.style.display='block';return;}
  }
  pd.style.display='none';
}
const atcBtn=document.getElementById('add-to-cart-btn');
const atcHint=document.getElementById('pvs-atc-hint');
const variantInput=document.getElementById('variant-id')||document.querySelector('[name="id"]');
function updateSticky(){
  if(!stickyEl)return;
  const sb=stickyEl.querySelector('.pvs-sticky__btn');
  const ss=stickyEl.querySelector('.pvs-sticky__size');
  const sp=stickyEl.querySelector('.pvs-sticky__price');
  const ready=state.width&&state.length&&state.tassels&&selectedVariantId;
  if(sb){sb.classList.toggle('is-ready',!!ready);sb.classList.toggle('is-locked',!ready);}
  if(ss)ss.textContent=state.width&&state.length?`${state.width} × ${state.length}${state.tassels?' · '+state.tassels:''}` : 'Select size';
  if(sp&&state.width&&state.length){const c=getPrice(state.width,state.length);sp.textContent=c?formatMoney(c):'';}
  else if(sp)sp.textContent='';
}
function updateATC(){
  if(!atcBtn)return;
  const ready=state.width&&state.length&&state.tassels;
  selectedVariantId=ready?getVariantId(state.width,state.length,state.tassels):null;
  if(ready&&selectedVariantId){
    atcBtn.disabled=false;
    atcBtn.classList.remove('is-locked');atcBtn.classList.add('is-ready');
    atcBtn.textContent='Add to Order';
    if(variantInput)variantInput.value=selectedVariantId;
    if(atcHint)atcHint.classList.remove('is-visible');
  }else{
    atcBtn.disabled=true;
    atcBtn.classList.add('is-locked');atcBtn.classList.remove('is-ready');
    atcBtn.textContent='Add to Order';
    if(atcHint)atcHint.classList.add('is-visible');
  }
  updateSticky();
}
function render(){
  updateStepIndicators();updatePanels();updateLengthOptions();
  updateDimensions();updatePrice();updateATC();
}
container.addEventListener('click',e=>{
  const btn=e.target.closest('.pvs-btn');
  if(!btn||btn.classList.contains('is-disabled'))return;
  const step=parseInt(btn.dataset.step),value=btn.dataset.value;
  if(step===1){
    state.width=value;state.length=null;state.tassels=null;
    document.getElementById('pvs-width-selected').textContent=value;
    document.getElementById('pvs-length-selected').textContent='';
    document.getElementById('pvs-tassels-selected').textContent='';
    document.querySelectorAll('#pvs-tassels-options .pvs-btn').forEach(b=>b.classList.remove('is-selected'));
  }else if(step===2){
    if(!state.width)return;
    state.length=value;state.tassels=null;
    document.getElementById('pvs-length-selected').textContent=value;
    document.getElementById('pvs-tassels-selected').textContent='';
    document.querySelectorAll('#pvs-tassels-options .pvs-btn').forEach(b=>b.classList.remove('is-selected'));
  }else if(step===3){
    if(!state.length)return;
    state.tassels=value;
    document.getElementById('pvs-tassels-selected').textContent=value;
  }
  const groupSel=`#pvs-${step===1?'width':step===2?'length':'tassels'}-options .pvs-btn`;
  document.querySelectorAll(groupSel).forEach(b=>b.classList.remove('is-selected'));
  btn.classList.add('is-selected');
  render();
  if(step<3){const np=document.getElementById(`pvs-step-${step+1}`);if(np)setTimeout(()=>np.scrollIntoView({behavior:'smooth',block:'nearest'}),150);}
});

/* ============================================================
   ADD TO CART — AJAX only (button is type="button", no form submit)
   Bug fix: read actual Shopify error when response is not OK
============================================================ */
if(atcBtn){
  /* Prevent any accidental form submit (belt-and-suspenders) */
  const atcForm=document.getElementById('add-to-cart-form');
  if(atcForm)atcForm.addEventListener('submit',e=>{e.preventDefault();e.stopPropagation();});

  atcBtn.addEventListener('click',async function(e){
    e.preventDefault();
    e.stopPropagation();
    if(!selectedVariantId||atcBtn.disabled)return;
    const origText='Add to Order';
    atcBtn.disabled=true;
    atcBtn.classList.remove('is-ready');atcBtn.classList.add('is-adding');
    atcBtn.textContent='Adding…';
    try{
      /* Step 1: Add variant to cart */
      const addRes=await fetch('/cart/add.js',{
        method:'POST',
        headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
        body:JSON.stringify({id:Number(selectedVariantId),quantity:1})
      });

      /* Read response body BEFORE checking status — Shopify error details are in the body */
      const addBody=await addRes.json();

      if(!addRes.ok){
        /* Shopify returns {status:422, description:"..."} or {errors:"..."} */
        const shopifyMsg=addBody.description||addBody.error||(typeof addBody.errors==='string'?addBody.errors:null)||`HTTP ${addRes.status}`;
        console.error('[Soul Rugs] /cart/add.js error:',addBody);
        throw new Error(shopifyMsg);
      }

      const addedItem=addBody; /* Successfully added item */

      /* Step 2: Fetch full cart for totals */
      const cartRes=await fetch('/cart.js',{headers:{'X-Requested-With':'XMLHttpRequest'}});
      const cartData=await cartRes.json();

      /* Step 3: Update header count */
      const countEl=document.getElementById('cart-count');
      if(countEl){countEl.textContent=cartData.item_count||'';countEl.style.display=cartData.item_count>0?'flex':'none';}

      /* Step 4: Open cart drawer with the added item */
      document.dispatchEvent(new CustomEvent('soul-rugs:item-added',{
        detail:{item:addedItem,cart:cartData}
      }));

      atcBtn.textContent='✓ Added!';
      atcBtn.classList.remove('is-adding');atcBtn.classList.add('is-ready');
      setTimeout(()=>{atcBtn.textContent=origText;atcBtn.disabled=false;},2500);
    }catch(err){
      console.error('[Soul Rugs] Add to cart failed:',err.message||err);
      atcBtn.textContent='Error – Try Again';
      atcBtn.disabled=false;
      atcBtn.classList.remove('is-adding');atcBtn.classList.add('is-ready');
      setTimeout(()=>{atcBtn.textContent=origText;},3000);
    }
  });
}

if(stickyEl){
  const stickyBtn=stickyEl.querySelector('.pvs-sticky__btn');
  if(stickyBtn)stickyBtn.addEventListener('click',()=>{
    if(selectedVariantId&&atcBtn&&!atcBtn.disabled)atcBtn.click();
  });
  if(atcBtn)new IntersectionObserver(entries=>entries.forEach(entry=>stickyEl.classList.toggle('is-visible',!entry.isIntersecting)),{threshold:0}).observe(atcBtn);
}
render();
})();

/* ============================================================
   SOUL RUGS — Gallery: Thumbnails + Touch Swipe + Lightbox
   Bug fix: added touchstart/touchend swipe events + dots update
============================================================ */
(function () {
  const gallery = document.getElementById('product-gallery');
  if (!gallery) return;
  const thumbs = Array.from(gallery.querySelectorAll('.gallery-thumb'));
  const slides = Array.from(gallery.querySelectorAll('.gallery-slide'));
  const dots   = Array.from(document.querySelectorAll('.prd-gallery-dot'));
  const lightbox = document.getElementById('zoom-lightbox');
  const lightboxImg = document.getElementById('zoom-img');
  const lightboxClose = document.getElementById('zoom-close');
  let currentIndex = 0;

  /* goTo: activate slide, thumbnail and dot */
  function goTo(index) {
    currentIndex = Math.max(0, Math.min(index, slides.length - 1));
    slides.forEach((s, i) => s.classList.toggle('gallery-slide--active', i === currentIndex));
    thumbs.forEach((t, i) => t.classList.toggle('gallery-thumb--active', i === currentIndex));
    dots.forEach((d, i) => d.classList.toggle('is-active', i === currentIndex));
    if (thumbs[currentIndex]) {
      thumbs[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }
  }

  /* Thumbnail clicks */
  thumbs.forEach((thumb, i) => { thumb.addEventListener('click', () => goTo(i)); });

  /* ============================================================
     MOBILE SWIPE — touchstart / touchend on gallery main area
     Detects horizontal swipe, ignores vertical scroll gestures
  ============================================================ */
  const mainEl = document.getElementById('gallery-main');
  if (mainEl && slides.length > 1) {
    let touchStartX = 0;
    let touchStartY = 0;
    let touchMoved  = false;

    mainEl.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
      touchStartY = e.changedTouches[0].clientY;
      touchMoved  = false;
    }, { passive: true });

    mainEl.addEventListener('touchmove', function (e) {
      const dx = Math.abs(e.changedTouches[0].clientX - touchStartX);
      const dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      /* Mark as swipe only if horizontal movement dominates */
      if (dx > 8 && dx > dy) touchMoved = true;
    }, { passive: true });

    mainEl.addEventListener('touchend', function (e) {
      if (!touchMoved) return; /* Tap → let click event handle lightbox */
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = e.changedTouches[0].clientY - touchStartY;
      /* Swipe threshold: min 40px horizontal, horizontal > vertical */
      if (Math.abs(dx) >= 40 && Math.abs(dx) > Math.abs(dy)) {
        goTo(dx < 0 ? currentIndex + 1 : currentIndex - 1);
        /* Prevent the tap-to-zoom that would fire after the swipe */
        e.preventDefault();
      }
      touchMoved = false;
    }, { passive: false }); /* passive:false allows preventDefault on touchend */
  }

  /* ============================================================
     LIGHTBOX
  ============================================================ */
  function openLightbox(index) {
    const img = slides[index] ? slides[index].querySelector('img') : null;
    const src = img ? (img.dataset.zoom || img.src) : '';
    if (!lightbox || !src) return;
    currentIndex = index;
    lightboxImg.src = src;
    lightbox.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function lightboxNav(dir) {
    currentIndex = (currentIndex + dir + slides.length) % slides.length;
    const img = slides[currentIndex] ? slides[currentIndex].querySelector('img') : null;
    if (lightboxImg && img) lightboxImg.src = img.dataset.zoom || img.src;
    goTo(currentIndex);
  }

  /* Open lightbox on slide click (desktop) — on mobile, swipe takes priority */
  slides.forEach((slide, i) => {
    slide.style.cursor = 'zoom-in';
    slide.addEventListener('click', () => {
      if (!touchMoved) openLightbox(i);
    });
  });

  /* Zoom button */
  gallery.querySelectorAll('.gallery-zoom-btn').forEach((btn, i) => {
    btn.addEventListener('click', e => { e.stopPropagation(); openLightbox(i); });
  });

  if (lightboxClose) lightboxClose.addEventListener('click', closeLightbox);
  if (lightbox) lightbox.addEventListener('click', e => { if (e.target === lightbox || e.target === lightboxImg) closeLightbox(); });

  /* Lightbox arrow buttons */
  if (lightbox && slides.length > 1) {
    const prev = document.createElement('button');
    prev.innerHTML = '&#8592;'; prev.setAttribute('aria-label', 'Previous');
    prev.style.cssText = 'position:fixed;left:1.5rem;top:50%;transform:translateY(-50%);background:rgba(248,243,236,0.08);border:1px solid rgba(248,243,236,0.15);color:#F8F3EC;width:48px;height:48px;border-radius:50%;font-size:20px;cursor:pointer;z-index:10001;display:flex;align-items:center;justify-content:center;';
    prev.addEventListener('click', e => { e.stopPropagation(); lightboxNav(-1); });
    const next = document.createElement('button');
    next.innerHTML = '&#8594;'; next.setAttribute('aria-label', 'Next');
    next.style.cssText = 'position:fixed;right:1.5rem;top:50%;transform:translateY(-50%);background:rgba(248,243,236,0.08);border:1px solid rgba(248,243,236,0.15);color:#F8F3EC;width:48px;height:48px;border-radius:50%;font-size:20px;cursor:pointer;z-index:10001;display:flex;align-items:center;justify-content:center;';
    next.addEventListener('click', e => { e.stopPropagation(); lightboxNav(1); });
    lightbox.appendChild(prev); lightbox.appendChild(next);
  }

  /* Keyboard navigation */
  document.addEventListener('keydown', e => {
    if (!lightbox || !lightbox.classList.contains('is-open')) return;
    if (e.key === 'Escape') closeLightbox();
    if (e.key === 'ArrowLeft') lightboxNav(-1);
    if (e.key === 'ArrowRight') lightboxNav(1);
  });

  /* Lightbox CSS */
  const style = document.createElement('style');
  style.textContent = '#zoom-lightbox{position:fixed;inset:0;background:rgba(0,0,0,0.95);z-index:9999;display:none;align-items:center;justify-content:center} #zoom-lightbox.is-open{display:flex} #zoom-lightbox .zoom-lightbox__img{max-width:88vw;max-height:88vh;object-fit:contain} #zoom-close{position:fixed;top:1.5rem;right:1.5rem;background:rgba(248,243,236,0.1);border:1px solid rgba(248,243,236,0.2);color:#F8F3EC;width:44px;height:44px;border-radius:50%;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:10001;font-size:20px}';
  document.head.appendChild(style);

  goTo(0);
})();

/* Variable scoping fix: touchMoved accessible in click handler */
var touchMoved = false;
